import React, {Component} from 'react';
import {ModalBody} from 'reactstrap';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {ReportFilter} from "../reports/ReportFilter";

export class ViewInsightsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            insightsHTML: null,
        };
        this.handleViewInsights = this.handleViewInsights.bind(this);
    }

    // API

    handleViewInsights(agencyClientAdAccountSelected, campaignSelected) {
        new APIClient(this.getGetInsightsHTMLURL(agencyClientAdAccountSelected, campaignSelected)).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    insightsHTML: response.data["html"]
                })
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody className={"insights"}>
                    <ReportFilter doOperation={this.handleViewInsights} />
                    <div className="modal-section">
                        <div className="form-row">
                            <div className={"markdown"}>
                                {this.renderInsightsHTML()}
                            </div>
                        </div>
                    </div>
                </ModalBody>
                {/*<ModalFooter></ModalFooter>*/}
            </form>
        )
    }

    renderInsightsHTML() {
        if(this.state.insightsHTML === null)
            return;

        return <div
            dangerouslySetInnerHTML={{__html: this.state.insightsHTML}}
        />;
    }

    // URLS

    getGetInsightsHTMLURL(agencyClientAdAccountSelected, campaignSelected) {
        return `${API_URL}insights/${agencyClientAdAccountSelected}/${campaignSelected}`
    }
}


